module.exports = __webpack_public_path__ + "static/media/truck-active.6296c470.svg";